import axios from "axios"
import useSWR from "swr"

const fetcher = async (url, params) => {
  return await axios.get(url, { params }).then((res) => {
    return res.data
  })
}

const useStoreBalanceStockRepositories = (params) => {
  const shouldFetch = params?.enabled !== false
  const requestParams = { ...params }

  delete requestParams.enabled

  const { data, error, mutate, isValidating } = useSWR(
    shouldFetch && requestParams.month
      ? [
          `${process.env.REACT_APP_INVENTORY_API_URL}/reports/store-balance-stock`,
          requestParams,
        ]
      : null,
    fetcher
  )

  return {
    data,
    // 230726: dulu mensyaratkan outlet_id — param yang dikirim halaman ini
    // outlet_ids (plural) dan boleh kosong (= semua outlet), jadi isLoading
    // selalu false dan tabel menampilkan "data kosong" saat masih fetch.
    // Syarat fetch yang sebenarnya hanya month (lihat key SWR di atas).
    isLoading: shouldFetch && !!requestParams.month && !error && !data,
    error,
    isValidating,
    mutate,
  }
}

export default useStoreBalanceStockRepositories
